'use client'
import { useContext } from 'react'
import { Typography, Button, Grid } from '@achieve/ascend'
import Section from 'components/Section'
import styles from './UnexpectedError.module.scss'
import { mainProductConfig } from 'constants/mainProductConfig'
import { LayoutContext } from 'providers/LayoutProvider'

function UnexpectedError() {
  const { state: { siteEnv } = {} } = useContext(LayoutContext)
  return (
    <Section>
      <Grid className={styles['container-grid']}>
        <Typography
          className={styles['text']}
          style={{ textAlign: 'center' }}
          data-testid="500-error-title-text"
          component="h1"
          variant="displayXl"
        >
          500 - Internal Server Error
        </Typography>
        <Typography
          className={styles['text']}
          style={{ textAlign: 'center' }}
          data-testid="500-error-subtitle-text"
          component="p"
          variant="headingLg"
        >
          An unexpected error occurred
        </Typography>
        <Grid className={styles['text']}>
          <Button
            className={styles['button']}
            data-testid="500-error-return-home-button"
            sx={{ mt: 4 }}
            href="/"
          >
            Take me back to {`${mainProductConfig[siteEnv || 'achieve']?.['URL']}`}
          </Button>
        </Grid>
      </Grid>
    </Section>
  )
}

export { UnexpectedError }
